// import throttle from 'lodash/throttle';
// import type {ChannelAuthorizationData} from 'pusher-js/types/src/core/auth/options';
// import type {ChannelAuthorizationCallback} from 'pusher-js/with-encryption';
import type {Auth} from 'firebase/auth';
import {signOut as fbSignOut} from 'firebase/auth';
// import {InteractionManager, Linking, NativeModules} from 'react-native';
import Onyx from 'react-native-onyx';
// import type {OnyxEntry, OnyxUpdate} from 'react-native-onyx';
// import type {ValueOf} from 'type-fest';
import * as ErrorUtils from '@libs/ErrorUtils';
import {KEYS_TO_PRESERVE} from '@userActions/App';
import * as PersistedRequests from '@userActions/PersistedRequests';
import * as PushNotification from '@userActions/PushNotification';
import * as Subscriptions from '@userActions/Subscriptions';
// import * as API from '@libs/API';
// import type {UserID} from '@src/types/onyx/OnyxCommon';
// import type {
//   AuthenticatePusherParams,
//   BeginAppleSignInParams,
//   BeginGoogleSignInParams,
//   BeginSignInParams,
//   RequestAccountValidationLinkParams,
//   RequestNewValidateCodeParams,
//   RequestUnlinkValidationLinkParams,
//   SignInUserWithLinkParams,
//   UnlinkLoginParams,
//   ValidateTwoFactorAuthParams,
// } from '@libs/API/parameters';
// import type SignInUserParams from '@libs/API/parameters/SignInUserParams';
// import {
//   READ_COMMANDS,
//   SIDE_EFFECT_REQUEST_COMMANDS,
//   WRITE_COMMANDS,
// } from '@libs/API/types';
// import * as Authentication from '@libs/Authentication';
// import HttpUtils from '@libs/HttpUtils';
import Log from '@libs/Log';
import Navigation from '@libs/Navigation/Navigation';
import navigationRef from '@libs/Navigation/navigationRef';
// import * as NetworkStore from '@libs/Network/NetworkStore';
// import NetworkConnection from '@libs/NetworkConnection';
import * as Pusher from '@libs/Pusher/pusher';
// import * as ReportUtils from '@libs/ReportUtils';
import Timers from '@libs/Timers';
// import {hideContextMenu} from '@pages/home/report/ContextMenu/ReportActionContextMenu';
// import * as Device from '@userActions/Device';
// import * as PriorityMode from '@userActions/PriorityMode';
// import redirectToSignIn from '@userActions/SignInRedirect';
import Timing from '@userActions/Timing';
// import CONFIG from '@src/CONFIG';
// import CONST from '@src/CONST';
import ONYXKEYS from '@src/ONYXKEYS';
import SCREENS from '@src/SCREENS';
import ERRORS from '@src/ERRORS';
import clearCache from './clearCache';

// let session: Session = {};
// let authPromiseResolver: ((value: boolean) => void) | null = null;
// Onyx.connect({
//   key: ONYXKEYS.SESSION,
//   callback: value => {
//     session = value ?? {};
//     if (session.authToken && authPromiseResolver) {
//       authPromiseResolver(true);
//       authPromiseResolver = null;
//     }
//   },
// });

// let stashedSession: Session = {};
// Onyx.connect({
//   key: ONYXKEYS.STASHED_SESSION,
//   callback: value => (stashedSession = value ?? {}),
// });

let hasCheckedAutoLogin = false;
Onyx.connect({
  key: ONYXKEYS.HAS_CHECKED_AUTO_LOGIN,
  callback: value => (hasCheckedAutoLogin = value ?? false),
});

// let stashedCredentials: Credentials = {};
// Onyx.connect({
//   key: ONYXKEYS.STASHED_CREDENTIALS,
//   callback: value => (stashedCredentials = value ?? {}),
// });

// let preferredLocale: ValueOf<typeof CONST.LOCALES> | null = null;
// Onyx.connect({
//   key: ONYXKEYS.NVP_PREFERRED_LOCALE,
//   callback: val => (preferredLocale = val),
// });

// function isSupportAuthToken(): boolean {
//   return session.authTokenType === CONST.AUTH_TOKEN_TYPES.SUPPORT;
// }

// /**
//  * Sets the SupportToken. This method will only be used on dev.
//  */
// function setSupportAuthToken(
//   supportAuthToken: string,
//   email: string,
//   userID: UserID,
// ) {
//   Onyx.merge(ONYXKEYS.SESSION, {
//     authTokenType: CONST.AUTH_TOKEN_TYPES.SUPPORT,
//     authToken: supportAuthToken,
//     email,
//     userID,
//   }).then(() => {
//     Log.info('[Supportal] Authtoken set');
//   });
//   Onyx.set(ONYXKEYS.LAST_VISITED_PATH, '');
// }

// function getShortLivedLoginParams() {
//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         ...CONST.DEFAULT_ACCOUNT_DATA,
//         isLoading: true,
//       },
//     },
//     // We are making a temporary modification to 'signedInWithShortLivedAuthToken' to ensure that 'App.openApp' will be called at least once
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.SESSION,
//       value: {
//         signedInWithShortLivedAuthToken: true,
//       },
//     },
//   ];

//   // Subsequently, we revert it back to the default value of 'signedInWithShortLivedAuthToken' in 'finallyData' to ensure the user is logged out on refresh
//   const finallyData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//       },
//     },
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.SESSION,
//       value: {
//         signedInWithShortLivedAuthToken: null,
//       },
//     },
//   ];

//   return {optimisticData, finallyData};
// }

// /**
//  * This method should be used when we are being redirected from oldDot to NewDot on a supportal request
//  */
// function signInWithSupportAuthToken(authToken: string) {
//   const {optimisticData, finallyData} = getShortLivedLoginParams();
//   API.read(
//     READ_COMMANDS.SIGN_IN_WITH_SUPPORT_AUTH_TOKEN,
//     {authToken},
//     {optimisticData, finallyData},
//   );
// }

// /**
//  * Clears the Onyx store and redirects user to the sign in page
//  */
// function signOut() {
//   Log.info('Flushing logs before signing out', true, {}, true);
//   const params = {
//     // Send current authToken because we will immediately clear it once triggering this command
//     authToken: NetworkStore.getAuthToken(),
//     partnerUserID: credentials?.autoGeneratedLogin ?? '',
//     partnerName: CONFIG.EXPENSIFY.PARTNER_NAME,
//     partnerPassword: CONFIG.EXPENSIFY.PARTNER_PASSWORD,
//     shouldRetry: false,
//   };

//   API.write(WRITE_COMMANDS.LOG_OUT, params);
// }

// /**
//  * Checks if the account is an anonymous account.
//  */
// function isAnonymousUser(sessionParam?: OnyxEntry<Session>): boolean {
//   return (
//     (sessionParam?.authTokenType ?? session.authTokenType) ===
//     CONST.AUTH_TOKEN_TYPES.ANONYMOUS
//   );
// }

// function hasStashedSession(): boolean {
//   return Boolean(
//     stashedSession.authToken &&
//       stashedCredentials.autoGeneratedLogin &&
//       stashedCredentials.autoGeneratedLogin !== '',
//   );
// }

// /**
//  * Checks if the user has authToken
//  */
// function hasAuthToken(): boolean {
//   return !!session.authToken;
// }

// function signOutAndRedirectToSignIn(
//   shouldResetToHome?: boolean,
//   shouldStashSession?: boolean,
// ) {
//   Log.info('Redirecting to Sign In because signOut() was called');
//   hideContextMenu(false);
//   if (!isAnonymousUser()) {
//     // We'll only call signOut if we're not stashing the session and this is not a supportal session,
//     // otherwise we'll call the API to invalidate the autogenerated credentials used for infinite
//     // session.
//     const isSupportal = isSupportAuthToken();
//     if (!isSupportal && !shouldStashSession) {
//       signOut();
//     }

//     // The function redirectToSignIn will clear the whole storage, so let's create our onyx params
//     // updates for the credentials before we call it
//     let onyxSetParams = {};

//     // If we are not currently using a support token, and we received stashSession as true, we need to
//     // store the credentials so the user doesn't need to login again after they finish their supportal
//     // action. This needs to computed before we call `redirectToSignIn`
//     if (!isSupportal && shouldStashSession) {
//       onyxSetParams = {
//         [ONYXKEYS.STASHED_CREDENTIALS]: credentials,
//         [ONYXKEYS.STASHED_SESSION]: session,
//       };
//     }
//     // If this is a supportal token, and we've received the parameters to stashSession as true, and
//     // we already have a stashedSession, that means we are supportaled, currently supportaling
//     // into another account and we want to keep the stashed data from the original account.
//     if (isSupportal && shouldStashSession && hasStashedSession()) {
//       onyxSetParams = {
//         [ONYXKEYS.STASHED_CREDENTIALS]: stashedCredentials,
//         [ONYXKEYS.STASHED_SESSION]: stashedSession,
//       };
//     }
//     // Now if this is a supportal access, we do not want to stash the current session and we have a
//     // stashed session, then we need to restore the stashed session instead of completely logging out
//     if (isSupportal && !shouldStashSession && hasStashedSession()) {
//       onyxSetParams = {
//         [ONYXKEYS.CREDENTIALS]: stashedCredentials,
//         [ONYXKEYS.SESSION]: stashedSession,
//       };
//     }
//     redirectToSignIn().then(() => {
//       Onyx.multiSet(onyxSetParams);
//     });
//   } else {
//     if (Navigation.isActiveRoute(ROUTES.SIGN_IN_MODAL)) {
//       return;
//     }
//     if (shouldResetToHome) {
//       Navigation.resetToHome();
//     }
//     Navigation.navigate(ROUTES.SIGN_IN_MODAL);
//     Linking.getInitialURL().then(url => {
//       const reportID = ReportUtils.getReportIDFromLink(url);
//       if (reportID) {
//         Onyx.merge(ONYXKEYS.LAST_OPENED_PUBLIC_ROOM_ID, reportID);
//       }
//     });
//   }
// }

/**
 * @param callback The callback to execute if the action is allowed
 * @param isAnonymousAction The action is allowed for anonymous or not
 * @returns same callback if the action is allowed, otherwise a function that signs out and redirects to sign in
 */
function checkIfActionIsAllowed<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TCallback extends ((...args: any[]) => any) | void,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>(callback: TCallback, isAnonymousAction = false): TCallback | (() => void) {
  // if (isAnonymousUser() && !isAnonymousAction) {
  //   return () => signOutAndRedirectToSignIn();
  // }
  return callback;
}

// /**
//  * Resend the validation link to the user that is validating their account
//  */
// function resendValidationLink(login = credentials.login) {
//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: true,
//         errors: null,
//         message: null,
//         loadingForm: CONST.FORMS.RESEND_VALIDATION_FORM,
//       },
//     },
//   ];
//   const successData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         message: 'resendValidationForm.linkHasBeenResent',
//         loadingForm: null,
//       },
//     },
//   ];
//   const failureData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         message: null,
//         loadingForm: null,
//       },
//     },
//   ];

//   const params: RequestAccountValidationLinkParams = {email: login};

//   API.write(WRITE_COMMANDS.REQUEST_ACCOUNT_VALIDATION_LINK, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// /**
//  * Request a new validate / magic code for user to sign in via passwordless flow
//  */
// function resendValidateCode(login = credentials.login) {
//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         errors: null,
//         loadingForm: CONST.FORMS.RESEND_VALIDATE_CODE_FORM,
//       },
//     },
//   ];
//   const finallyData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         loadingForm: null,
//       },
//     },
//   ];

//   const params: RequestNewValidateCodeParams = {email: login};

//   API.write(WRITE_COMMANDS.REQUEST_NEW_VALIDATE_CODE, params, {
//     optimisticData,
//     finallyData,
//   });
// }

// type OnyxData = {
//   optimisticData: OnyxUpdate[];
//   successData: OnyxUpdate[];
//   failureData: OnyxUpdate[];
// };

// /**
//  * Constructs the state object for the BeginSignIn && BeginAppleSignIn API calls.
//  */
// function signInAttemptState(): OnyxData {
//   return {
//     optimisticData: [
//       {
//         onyxMethod: Onyx.METHOD.MERGE,
//         key: ONYXKEYS.ACCOUNT,
//         value: {
//           ...CONST.DEFAULT_ACCOUNT_DATA,
//           isLoading: true,
//           message: null,
//           loadingForm: CONST.FORMS.LOGIN_FORM,
//         },
//       },
//     ],
//     successData: [
//       {
//         onyxMethod: Onyx.METHOD.MERGE,
//         key: ONYXKEYS.ACCOUNT,
//         value: {
//           isLoading: false,
//           loadingForm: null,
//         },
//       },
//       {
//         onyxMethod: Onyx.METHOD.MERGE,
//         key: ONYXKEYS.CREDENTIALS,
//         value: {
//           validateCode: null,
//         },
//       },
//     ],
//     failureData: [
//       {
//         onyxMethod: Onyx.METHOD.MERGE,
//         key: ONYXKEYS.ACCOUNT,
//         value: {
//           isLoading: false,
//           loadingForm: null,
//           errors: ErrorUtils.getMicroSecondOnyxError(
//             'loginForm.cannotGetAccountDetails',
//           ),
//         },
//       },
//     ],
//   };
// }

// /**
//  * Checks the API to see if an account exists for the given login.
//  */
// function beginSignIn(email: string) {
//   const {optimisticData, successData, failureData} = signInAttemptState();

//   const params: BeginSignInParams = {email};

//   API.read(READ_COMMANDS.BEGIN_SIGNIN, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// /**
//  * Given an idToken from Sign in with Apple, checks the API to see if an account
//  * exists for that email address and signs the user in if so.
//  */
// function beginAppleSignIn(idToken: string | undefined | null) {
//   const {optimisticData, successData, failureData} = signInAttemptState();

//   const params: BeginAppleSignInParams = {idToken, preferredLocale};

//   API.write(WRITE_COMMANDS.SIGN_IN_WITH_APPLE, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// /**
//  * Shows Google sign-in process, and if an auth token is successfully obtained,
//  * passes the token on to the Expensify API to sign in with
//  */
// function beginGoogleSignIn(token: string | null) {
//   const {optimisticData, successData, failureData} = signInAttemptState();

//   const params: BeginGoogleSignInParams = {token, preferredLocale};

//   API.write(WRITE_COMMANDS.SIGN_IN_WITH_GOOGLE, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// /**
//  * Will create a temporary login for the user in the passed authenticate response which is used when
//  * re-authenticating after an authToken expires.
//  */
// function signInWithShortLivedAuthToken(email: string, authToken: string) {
//   const {optimisticData, finallyData} = getShortLivedLoginParams();

//   // If the user is signing in with a different account from the current app, should not pass the auto-generated login as it may be tied to the old account.
//   // scene 1: the user is transitioning to newDot from a different account on oldDot.
//   // scene 2: the user is transitioning to desktop app from a different account on web app.
//   const oldPartnerUserID =
//     credentials.login === email && credentials.autoGeneratedLogin
//       ? credentials.autoGeneratedLogin
//       : '';
//   API.read(
//     READ_COMMANDS.SIGN_IN_WITH_SHORT_LIVED_AUTH_TOKEN,
//     {authToken, oldPartnerUserID, skipReauthentication: true},
//     {optimisticData, finallyData},
//   );
// }

// /**
//  * Sign the user into the application. This will first authenticate their account
//  * then it will create a temporary login for them which is used when re-authenticating
//  * after an authToken expires.
//  *
//  * @param validateCode - 6 digit code required for login
//  */
// function signIn(validateCode: string, twoFactorAuthCode?: string) {
//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         ...CONST.DEFAULT_ACCOUNT_DATA,
//         isLoading: true,
//         loadingForm: twoFactorAuthCode
//           ? CONST.FORMS.VALIDATE_TFA_CODE_FORM
//           : CONST.FORMS.VALIDATE_CODE_FORM,
//       },
//     },
//   ];

//   const successData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         loadingForm: null,
//       },
//     },
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.CREDENTIALS,
//       value: {
//         validateCode,
//       },
//     },
//   ];

//   const failureData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         loadingForm: null,
//       },
//     },
//   ];

//   Device.getDeviceInfoWithID().then(deviceInfo => {
//     const params: SignInUserParams = {
//       twoFactorAuthCode,
//       email: credentials.login,
//       preferredLocale,
//       deviceInfo,
//     };

//     // Conditionally pass a password or validateCode to command since we temporarily allow both flows
//     if (validateCode || twoFactorAuthCode) {
//       params.validateCode = validateCode || credentials.validateCode;
//     }

//     API.write(WRITE_COMMANDS.SIGN_IN_USER, params, {
//       optimisticData,
//       successData,
//       failureData,
//     });
//   });
// }

// function signInWithValidateCode(
//   userID: UserID,
//   code: string,
//   twoFactorAuthCode = '',
// ) {
//   // If this is called from the 2fa step, get the validateCode directly from onyx
//   // instead of the one passed from the component state because the state is changing when this method is called.
//   const validateCode = twoFactorAuthCode ? credentials.validateCode : code;

//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         ...CONST.DEFAULT_ACCOUNT_DATA,
//         isLoading: true,
//         loadingForm: twoFactorAuthCode
//           ? CONST.FORMS.VALIDATE_TFA_CODE_FORM
//           : CONST.FORMS.VALIDATE_CODE_FORM,
//       },
//     },
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.SESSION,
//       value: {autoAuthState: CONST.AUTO_AUTH_STATE.SIGNING_IN},
//     },
//   ];

//   const successData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         loadingForm: null,
//       },
//     },
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.CREDENTIALS,
//       value: {
//         userID,
//         validateCode,
//       },
//     },
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.SESSION,
//       value: {autoAuthState: CONST.AUTO_AUTH_STATE.JUST_SIGNED_IN},
//     },
//   ];

/**
 * Clear the login information when the user goes back to first Login step
 */
function clearSignInData() {
  Onyx.multiSet({
    [ONYXKEYS.FORMS.AUTH_FORM]: null,
    [ONYXKEYS.FORMS.AUTH_FORM_DRAFT]: null,
  });
}

/**
 * Reset all current params of the Home route
 */
function resetHomeRouteParams() {
  Navigation.isNavigationReady().then(() => {
    const routes = navigationRef.current?.getState().routes;
    const homeRoute = routes?.find(route => route.name === SCREENS.HOME);

    const emptyParams: Record<string, undefined> = {};
    Object.keys(homeRoute?.params ?? {}).forEach(paramKey => {
      emptyParams[paramKey] = undefined;
    });

    Navigation.setParams(emptyParams, homeRoute?.key ?? '');
  });
}

/** Save the information about whether the app has attempted to auto login the user */
function setHasCheckedAutoLogin(val: boolean) {
  if (hasCheckedAutoLogin === val) {
    return;
  }
  // Update the in-memory cache synchronously so subsequent calls in the same tick observe the new value
  // before the Onyx.merge callback runs. Without this, a rapid false→true sequence on InitialScreen focus
  // can collapse to false because the second call still sees the old cache and short-circuits.
  hasCheckedAutoLogin = val;
  Onyx.merge(ONYXKEYS.HAS_CHECKED_AUTO_LOGIN, val);
}

/**
 * Put any logic that needs to run when we are signed out here. This can be triggered when the current tab or another tab signs out.
 * - Cancels pending network calls - any lingering requests are discarded to prevent unwanted storage writes
 * - Clears all current params of the Home route - the login page URL should not contain any parameter
 */
function cleanupSession() {
  // Tear down the realtime socket so stale `private-user-<uid>` subscriptions
  // don't survive logout. Without this the socket is reused across account
  // switches on the same device, leaving the previous user's channel bound and
  // leaking their onyxApiUpdate stream into the next user's Onyx store.
  Pusher.disconnect();
  Timers.clearAll();
  // PriorityMode.resetHasReadRequiredDataFromStorage();
  // HttpUtils.cancelPendingRequests();
  // Drop any queued/in-flight writes so the previous user's pending requests are
  // never replayed under the next account that signs in on this device.
  PersistedRequests.clear();
  // NetworkConnection.clearReconnectionCallbacks();
  // SessionUtils.resetDidUserLogInDuringSession();
  resetHomeRouteParams();
  // Wipe the entire Onyx store except the device-/build-level allowlist
  // (`KEYS_TO_PRESERVE`). This is the security-critical step of sign-out and of
  // account deletion (CloseAccount routes through this same path): every per-user
  // key is cleared by DEFAULT rather than by a hand-maintained denylist, so a key
  // added later can't silently leak across an account switch. This subsumes the
  // keys we used to null out by hand and adds the ones that previously survived —
  // USER_LOCATION, USER_PRIVATE_DATA (incl. DOB), DATA_VISIBILITY, PREFERENCES,
  // USER, the drinking-session/drinks/session-location collections, and the
  // admin-only feedback/bug lists — plus the SESSION token + email and the
  // CREDENTIALS key. Notable knock-on effects that the old explicit clears
  // covered and `Onyx.clear` keeps covering:
  //  - IS_LOADING_APP is removed, so a stale `false` can't open the
  //    onboarding/terms readiness gates before the next bootstrap finishes.
  //  - USER_DATA_HYDRATED is removed: the onboarding gate reads it as `=== true`,
  //    so a removed key and an explicit `false` are equivalent — this session's
  //    "app/open delivered the user record" proof can't carry into the next
  //    sign-in (the returning-user fix, #1435).
  //  - USER_DATA_LIST is removed, so a poisoned/mid-onboarding record can't
  //    re-route an already-onboarded user back into onboarding (2026-06-11 repro).
  //  - ONYX_UPDATES_LAST_UPDATE_ID_APPLIED_TO_CLIENT is removed, so the next
  //    (per-user) update sequence isn't compared against the prior account's
  //    counter and silently skipped.
  // `Onyx.clear` re-applies the preserved keys' initial states, so the next
  // sign-in's `openApp` rehydrates a clean store. On native this complements the
  // `clearCache()` below, which wipes the on-disk image cache Onyx doesn't own;
  // on web `Onyx.clear` is what actually purges the store (clearCache is a no-op).
  Onyx.clear(KEYS_TO_PRESERVE);
  clearCache().then(() => {
    Log.info('Cleared all cache data', true, {}, true);
  });
  Timing.clearData();
}

// function clearLoginMessages() {
//   Onyx.merge(ONYXKEYS.LOGIN, {
//     success: '',
//     errors: null,
//     message: null,
//     isLoading: false,
//   });
// }

// function setAccountError(error: string) {
//   Onyx.merge(ONYXKEYS.ACCOUNT, {
//     errors: ErrorUtils.getMicroSecondOnyxErrorObject(error, true),
//   });
// }

// // It's necessary to throttle requests to reauthenticate since calling this multiple times will cause Pusher to
// // reconnect each time when we only need to reconnect once. This way, if an authToken is expired and we try to
// // subscribe to a bunch of channels at once we will only reauthenticate and force reconnect Pusher once.
// const reauthenticatePusher = throttle(
//   () => {
//     Log.info('[Pusher] Re-authenticating and then reconnecting');
//     Authentication.reauthenticate(
//       SIDE_EFFECT_REQUEST_COMMANDS.AUTHENTICATE_PUSHER,
//     )
//       .then(Pusher.reconnect)
//       .catch(() => {
//         console.debug(
//           '[PusherConnectionManager]',
//           'Unable to re-authenticate Pusher because we are offline.',
//         );
//       });
//   },
//   5000,
//   {trailing: false},
// );

// function authenticatePusher(
//   socketID: string,
//   channelName: string,
//   callback: ChannelAuthorizationCallback,
// ) {
//   Log.info('[PusherAuthorizer] Attempting to authorize Pusher', false, {
//     channelName,
//   });

//   const params: AuthenticatePusherParams = {
//     // eslint-disable-next-line @typescript-eslint/naming-convention
//     socket_id: socketID,
//     // eslint-disable-next-line @typescript-eslint/naming-convention
//     channel_name: channelName,
//     shouldRetry: false,
//     forceNetworkRequest: true,
//   };

//   // We use makeRequestWithSideEffects here because we need to authorize to Pusher (an external service) each time a user connects to any channel.
//   // eslint-disable-next-line rulesdir/no-api-side-effects-method
//   API.makeRequestWithSideEffects(
//     SIDE_EFFECT_REQUEST_COMMANDS.AUTHENTICATE_PUSHER,
//     params,
//   )
//     .then(response => {
//       if (response?.jsonCode === CONST.JSON_CODE.NOT_AUTHENTICATED) {
//         Log.hmmm(
//           '[PusherAuthorizer] Unable to authenticate Pusher because authToken is expired',
//         );
//         callback(
//           new Error(
//             'Pusher failed to authenticate because authToken is expired',
//           ),
//           {auth: ''},
//         );

//         // Attempt to refresh the authToken then reconnect to Pusher
//         reauthenticatePusher();
//         return;
//       }

//       if (response?.jsonCode !== CONST.JSON_CODE.SUCCESS) {
//         Log.hmmm(
//           '[PusherAuthorizer] Unable to authenticate Pusher for reason other than expired session',
//         );
//         callback(
//           new Error(
//             `Pusher failed to authenticate because code: ${response?.jsonCode} message: ${response?.message}`,
//           ),
//           {auth: ''},
//         );
//         return;
//       }

//       Log.info('[PusherAuthorizer] Pusher authenticated successfully', false, {
//         channelName,
//       });
//       callback(null, response as ChannelAuthorizationData);
//     })
//     .catch(error => {
//       Log.hmmm('[PusherAuthorizer] Unhandled error: ', {channelName, error});
//       callback(new Error('AuthenticatePusher request failed'), {auth: ''});
//     });
// }

// /**
//  * Request a new validation link / magic code to unlink an unvalidated secondary login from a primary login
//  */
// function requestUnlinkValidationLink() {
//   const optimisticData = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: true,
//         errors: null,
//         message: null,
//         loadingForm: CONST.FORMS.UNLINK_LOGIN_FORM,
//       },
//     },
//   ];
//   const successData = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         message: 'unlinkLoginForm.linkSent',
//         loadingForm: null,
//       },
//     },
//   ];
//   const failureData = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         loadingForm: null,
//       },
//     },
//   ];

//   const params: RequestUnlinkValidationLinkParams = {email: credentials.login};

//   API.write(WRITE_COMMANDS.REQUEST_UNLINK_VALIDATION_LINK, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// function unlinkLogin(userID: UserID, validateCode: string) {
//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         ...CONST.DEFAULT_ACCOUNT_DATA,
//         isLoading: true,
//       },
//     },
//   ];
//   const successData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//         message: 'unlinkLoginForm.succesfullyUnlinkedLogin',
//       },
//     },
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.CREDENTIALS,
//       value: {
//         login: '',
//       },
//     },
//   ];
//   const failureData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//       },
//     },
//   ];

//   const params: UnlinkLoginParams = {
//     userID,
//     validateCode,
//   };

//   API.write(WRITE_COMMANDS.UNLINK_LOGIN, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// /**
//  * Toggles two-factor authentication based on the `enable` parameter
//  */
// function toggleTwoFactorAuth(enable: boolean) {
//   const optimisticData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: true,
//       },
//     },
//   ];

//   const successData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//       },
//     },
//   ];

//   const failureData: OnyxUpdate[] = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//       },
//     },
//   ];

//   API.write(
//     enable
//       ? WRITE_COMMANDS.ENABLE_TWO_FACTOR_AUTH
//       : WRITE_COMMANDS.DISABLE_TWO_FACTOR_AUTH,
//     {},
//     {optimisticData, successData, failureData},
//   );
// }

// function validateTwoFactorAuth(twoFactorAuthCode: string) {
//   const optimisticData = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: true,
//       },
//     },
//   ];

//   const successData = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//       },
//     },
//   ];

//   const failureData = [
//     {
//       onyxMethod: Onyx.METHOD.MERGE,
//       key: ONYXKEYS.ACCOUNT,
//       value: {
//         isLoading: false,
//       },
//     },
//   ];

//   const params: ValidateTwoFactorAuthParams = {twoFactorAuthCode};

//   API.write(WRITE_COMMANDS.TWO_FACTOR_AUTH_VALIDATE, params, {
//     optimisticData,
//     successData,
//     failureData,
//   });
// }

// /**
//  * Waits for a user to sign in.
//  *
//  * If the user is already signed in (`authToken` is truthy), the promise resolves immediately.
//  * Otherwise, the promise will resolve when the `authToken` in `ONYXKEYS.SESSION` becomes truthy via the Onyx callback.
//  * The promise will not reject on failed login attempt.
//  *
//  * @returns A promise that resolves to `true` once the user is signed in.
//  * @example
//  * waitForUserSignIn().then(() => {
//  *   console.log('User is signed in!');
//  * });
//  */
// function waitForUserSignIn(): Promise<boolean> {
//   return new Promise<boolean>(resolve => {
//     if (session.authToken) {
//       resolve(true);
//     } else {
//       authPromiseResolver = resolve;
//     }
//   });
// }

// function handleExitToNavigation(exitTo: Route | HybridAppRoute) {
//   InteractionManager.runAfterInteractions(() => {
//     waitForUserSignIn().then(() => {
//       Navigation.waitForProtectedRoutes().then(() => {
//         const url = NativeModules.HybridAppModule
//           ? Navigation.parseHybridAppUrl(exitTo)
//           : (exitTo as Route);
//         Navigation.navigate(url);
//       });
//     });
//   });
// }

// function signInWithValidateCodeAndNavigate(
//   userID: UserID,
//   validateCode: string,
//   twoFactorAuthCode = '',
//   exitTo?: Route | HybridAppRoute,
// ) {
//   signInWithValidateCode(userID, validateCode, twoFactorAuthCode);
//   if (exitTo) {
//     handleExitToNavigation(exitTo);
//   } else {
//     Navigation.goBack();
//   }
// }

// /**
//  * check if the route can be accessed by anonymous user
//  *
//  * @param {string} route
//  */

// const canAnonymousUserAccessRoute = (route: string) => {
//   const reportID = ReportUtils.getReportIDFromLink(route);
//   if (reportID) {
//     return true;
//   }
//   const parsedReportRouteParams = ReportUtils.parseReportRouteParams(route);
//   let routeRemovedReportId = route;
//   if ((parsedReportRouteParams as {reportID: string})?.reportID) {
//     routeRemovedReportId = route.replace(
//       (parsedReportRouteParams as {reportID: string})?.reportID,
//       ':reportID',
//     );
//   }
//   if (route.startsWith('/')) {
//     routeRemovedReportId = routeRemovedReportId.slice(1);
//   }
//   const routesAccessibleByAnonymousUser = [
//     ROUTES.SIGN_IN_MODAL,
//     ROUTES.REPORT_WITH_ID_DETAILS.route,
//     ROUTES.REPORT_WITH_ID_DETAILS_SHARE_CODE.route,
//     ROUTES.CONCIERGE,
//   ];
//   const isMagicLink = CONST.REGEX.ROUTES.VALIDATE_LOGIN.test(`/${route}`);

//   if (
//     (routesAccessibleByAnonymousUser as string[]).includes(
//       routeRemovedReportId,
//     ) ||
//     isMagicLink
//   ) {
//     return true;
//   }
//   return false;
// };

/**
 * Signs out the user from the app. All errors should be handled within this function.
 *
 * @param auth Auth object from firebase
 */
async function signOut(auth: Auth) {
  try {
    // Unregister this device first: the server call needs the still-valid ID
    // token, and it can't be queued (cleanupSession drops the queue). Bounded
    // and never throws, so sign-out can't hang on it. With no current user
    // (account just deleted, the server already dropped its devices) only the
    // local FCM token is deleted.
    await PushNotification.unregisterDevice(!!auth.currentUser);
    await fbSignOut(auth);
    Subscriptions.forget();
  } catch (error) {
    ErrorUtils.raiseAppError(ERRORS.AUTH.SIGN_OUT_FAILED, error);
  }
}

export {
  checkIfActionIsAllowed,
  setHasCheckedAutoLogin,
  cleanupSession,
  signOut,
  clearSignInData,
};
